// extracted by mini-css-extract-plugin
module.exports = {"LandingPage":"Landing_LandingPage__1cm1M","CardItems":"Landing_CardItems__2OKed"};